<mat-toolbar color="secondary">
  <ldw-document-title [document]="document"></ldw-document-title>
  <span class="spacer"></span>
  <div class="buttons">
    <button mat-icon-button (click)="close()" matTooltip="{{ showToolTip()? ('DIALOGS.CLOSE' | translate):'' }}">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-toolbar>
<ldw-node-value-list-view [list]="list"></ldw-node-value-list-view>


